import FooterAboutLinks from './FooterAboutLinks'
import FooterAwards from './FooterAwards'
import FooterCareerLinks from './FooterCareerLinks'
import FooterDisclaimer from './FooterDisclaimer'
import FooterMoreLinks from './FooterMoreLinks'
import FooterProductsLinks from './FooterProductsLinks'
import FooterSocials from './FooterSocials'

const Footer = () => {
  const copyrightText = `© ${new Date().getFullYear()} Creditstar Group AS & subsidiaries`

  return (
    <footer id="footer">
      <div className="container wide">
        <div className="footer-col-wrapper">
          <div className="footer-col">
            <FooterAboutLinks />
          </div>
          <div className="footer-col">
            <FooterProductsLinks />
          </div>
          <div className="footer-col">
            <FooterCareerLinks />
          </div>

          <div className="footer-col">
            <FooterMoreLinks />
          </div>
        </div>
        <div className="footer-col-wrapper">
          <FooterAwards />
        </div>
      </div>
      <div className="container wide">
        <div className="footer-disclaimer-wrapper">
          <div className="footer-col">{copyrightText}</div>
          <div className="footer-col">
            <FooterSocials />
          </div>
        </div>
      </div>
      <div className="container wide">
        <FooterDisclaimer />
      </div>
    </footer>
  )
}

export default Footer
